export default {
  equalsField: function (otherName, message) {
    return this.test('equalsField', message, function (value) {
      const otherValue = this.parent[otherName]
      return !value || JSON.stringify(value) === JSON.stringify(otherValue);
    })
  },
  notEqualsField: function (otherName, message) {
    return this.test('notEqualsField', message, function (value) {
      const otherValue = this.parent[otherName]
      return !value || JSON.stringify(value) !== JSON.stringify(otherValue);
    })
  }
}


// WEBPACK FOOTER //
// ./src/components/Form/Validation/MixedValidation.js